import { render } from "./PictureCompression.vue?vue&type=template&id=4bb0b37f&scoped=true"
import script from "./PictureCompression.vue?vue&type=script&lang=js"
export * from "./PictureCompression.vue?vue&type=script&lang=js"

import "./PictureCompression.vue?vue&type=style&index=0&id=4bb0b37f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bb0b37f"]])

export default __exports__